// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { z } from 'zod';

export const investmentObjectivesSchema = z.object({
  q_investment_horizon: z.enum(['lt_1y', '1_3y', '3_5y', 'gt_5y']),
  q_risk_tolerance: z.enum([
    'no_risk_capital',
    'small_temp_loss',
    'mod_risk_return',
    'high_risk_high_return',
  ]),
  q_investment_purpose: z.enum([
    'capital_preservation',
    'limited_growth',
    'moderate_growth',
    'high_growth_high_risk',
  ]),
  q_loss_reaction: z.enum([
    'avoid_volatile_assets',
    'sell_all_immediately',
    'sell_partial',
    'hold_position',
    'increase_investment',
  ]),
});

export type InvestmentObjectivesFormData = z.infer<
  typeof investmentObjectivesSchema
>;
